module.exports = __webpack_public_path__ + "media/images/icon-arrow-right-yellow-7695e0f3d94beb243e9cfa42308d57af.svg";